// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var HeroText__titleContainer = "HeroText-module--HeroText__titleContainer--3FOdu";
export var HeroText__titleContainer__line2 = "HeroText-module--HeroText__titleContainer__line2--1tt9q";
export var HeroText__copyContainer = "HeroText-module--HeroText__copyContainer--2Z16L";